<template>
  <div>
    <Row class="user" type="flex">
      <Col :span="4" class="user-item" v-for="item in list" :key="item.id">
        <img
          class="item-logo"
          v-if="item.headPhoto"
          :src="`${$global.imgUrl}${item.headPhoto}`"
          alt=""
        />
        <div style="width: 100px;height: 100px;margin: 0 auto;" v-else><Big width="100" height="100" size="20" :big="item.name" /></div>
        <div class="name">{{ item.name }}</div>
        <div class="job">
          <span
            v-for="obj in item.title"
            :key="obj.id"
            style="margin-right: 5px"
            >{{ obj.levelThreeName }}</span
          >
        </div>
      </Col>
    </Row>
    <div class="more" v-if="isMore && orgUser.length > 6" @click="isMore = false">展开全部</div>
  </div>
</template>

<script>
export default {
  name: "user",
  props: ["orgUser"],
  computed: {
    list() {
      let arr = [];
      if (this.isMore) {
        arr = [...this.orgUser].splice(0, 6);
      } else {
        arr = [...this.orgUser];
      }
      return arr;
    },
  },
  data() {
    return {
      isMore: true,
    };
  },
};
</script>

<style lang="scss" scoped>
.user {
  overflow: hidden;
  margin-top: 36px;
  .user-item {
    text-align: center;
    margin-bottom: 30px;
    padding: 0 10px;
    .item-logo {
      width: 100px;
      height: 100px;
      border-radius: 50px;
    }
    .name {
      margin-top: 22px;
      font-size: 18px;
      color: #263d78;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .job {
      line-height: 28px;
      font-size: 14px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.more {
  margin: 0 auto;
  width: 200px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border: 1px solid #a3cbe7;
  border-radius: 10px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
}
</style>
